import React, { useState, useEffect} from "react";
import { useNavigate } from 'react-router-dom';
const CLOUDINARY_BASE = `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_NAME}/image/upload/`;

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

function horizontalSpacer(width) {
  return <div style={{ display: "inline-block", width: width }}></div>;
}

function verticalSpacer(height) {
  return <div style={{ height: height }}></div>;
}




function HomePage() {
   const [AllProductsInformation, setAllProductsInformation] = useState([]);
   const [productImages, setProductImages] = useState({});
   const [itemsInCart, setItemsInCartCart] = useState([])
   const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  

  function lookAtCart(parsedCartData){
      let cartItems = []
      for (let i = 0; i < parsedCartData.length; i++){
        cartItems.push(parsedCartData[i].productInfo.pid)
      }
      setItemsInCartCart(cartItems)

  }

  useEffect(() => {
      fetch(`${process.env.REACT_APP_API_BASE_URL}api/users/allProductsInformation`)
        .then(res => res.json())
        .then(data => {
          setAllProductsInformation(data);
          fetchAllProductImages(data); // Pass the data directly here
          const userCartFromStorage = localStorage.getItem("userCart");
          if(userCartFromStorage){
            const parsedCartData = JSON.parse(userCartFromStorage);
            lookAtCart(parsedCartData)
          }
        })
        .catch(err => console.error(err));
    }, []);

  const windowSize = useWindowSize();
  
  // No longer needed - using product-images API
  // const thumbnailByPid = React.useMemo(() => {
  //   const map = {};
  //   ProductThumbnail.forEach(img => {
  //     map[img.pid] = img.ImageName;
  //   });
  //   return map;
  // }, [ProductThumbnail]);


  function handleProductClick(product){
    // const queryString = new URLSearchParams(product).toString();
    // window.location.href = `/product?${queryString}`;
    const productWithImages = {
    ...product,
    // Pass first image or all images as JSON
    imageUrl: productImages[product.pid] && productImages[product.pid].length > 0 
      ? productImages[product.pid][0] 
      : '',
    // Optional: pass all images as JSON string
    allImages: productImages[product.pid] 
      ? JSON.stringify(productImages[product.pid]) 
      : '[]',
    productInfo: product 
      ? JSON.stringify(product) 
      : '[]'
  };
  
  const queryString = new URLSearchParams(productWithImages).toString();
  //console.log(queryString)
  //window.location.replace(`/product?${queryString}`);
  navigate(`/product?${queryString}`);
  }


const fetchAllProductImages = async (products) => {
  const imagesData = {};

  await Promise.all(
    products.map(async (product) => {
      try {
        const url = `${process.env.REACT_APP_API_BASE_URL}api/users/product-images/${product.pid}`;
        //console.log("Fetching from:", url);
        
        const response = await fetch(url);
        
        if (response.ok) {
          const imageUrls = await response.json();
          //console.log(`Received URLs for product ${product.pid}:`, imageUrls);
          imagesData[product.pid] = imageUrls;
        }
      } catch (error) {
        console.error("Fetch error:", error);
        imagesData[product.pid] = [];
      }
    })
  );

  //console.log('All product images data:', imagesData);
  setProductImages(imagesData);
};



// justifyContent: "center", gap: 40

  return (
    <div className="home-page" style={{ padding: 32, display: "grid", gridTemplateColumns: "repeat(auto-fit, 260px)",  flexDirection: "row", flexWrap: "wrap", justifyContent: "center", gap: 40, }}>
      
      {AllProductsInformation.map(product => (
        <div
          key={product.pid}
          className="homeSheetsContainer"
          style={{
            background: "#89807c", //"rgba(139, 132, 132, 0.9)",
            border: "1px solid #a09692",
            borderRadius: 25,
            width: 260,
            height: 410,
            paddingTop: 5,
            paddingLeft: 3,
            paddingRight: 6,
            paddingBottom: 10,
            cursor: 'pointer',
            boxShadow: "0px 5px 5px #4b4745"
            // boxSizing: 'border-box'
          }}
          onClick={()=>handleProductClick(product)}
        >
          {/* Display image from API */}
          {productImages[product.pid] && productImages[product.pid].length > 0 ? (
            <img
              style={{
                width: "auto",
                height: 270,
                objectFit: 'cover',
                borderRadius: 20,
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                border: "1px solid rgb(79, 67, 54, 0.5)",
                display: "block",
                margin: "0 auto",
                boxShadow: "0px 10px 20px rgba(0,0,0,0.5)"
              }}
              src={productImages[product.pid][0]} // Already a complete URL
              alt={product.pname}
              className="homeSheetImage"
              onError={(e) => {
                console.error("Image failed to load:", productImages[product.pid][0]);
                e.target.style.display = 'none';
              }}
            />
          ) : (
            // No image available
            <div style={{
              width: "auto",
              height: 270,
              backgroundColor: '#e0e0e0',
              borderRadius: 20,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: 5,
              color: '#999'
            }}>
              No Image Available
            </div>
          )}

          <p style={{ fontSize: 18, fontWeight: 600 }}>
            {product.pname}
          </p>

          <p >Size: {product.size}</p>

          <div style={{ fontSize: 16, fontWeight: 500, paddingBottom: 20 }}>
            ${Number(product.price).toFixed(2)}
            {horizontalSpacer(111)}
            <button style={{
                padding: "7px 10px",
                borderRadius: 12,
                border: "1px solid #686666",
                background: "rgb(248, 198, 149)",
                cursor: "pointer",
                marginLeft: 12,
                color: "#000000ff"
              }}type="button"onClick={(e) => {
                e.stopPropagation(); //stops the event from bubbling up
                if(itemsInCart && !itemsInCart.includes(product.pid)){
                const userCartFromStorage = localStorage.getItem("userCart");
                if(!userCartFromStorage){
                  const userCartToStorage1 = []
                  const userCartToStorage = {
                    productInfo: product,
                    productPictures: productImages[product.pid],
                    count: 1
                  }
                  userCartToStorage1.push(userCartToStorage)
                  console.log(userCartToStorage1)
                  lookAtCart(userCartToStorage1)
                  localStorage.setItem('userCart', JSON.stringify(userCartToStorage1));
                }
                else{
                  const parsedCartData = JSON.parse(userCartFromStorage);
                  const userCartToStorage = []
                  for (let i = 0; i < parsedCartData.length; i++){
                    userCartToStorage.push(parsedCartData[i])
                  }
                  const userCartToStorage2 = {
                    productInfo: product,
                    productPictures: productImages[product.pid],
                    count: 1
                  }
                  let foundLocation = false
                  for (let i = 0; i < userCartToStorage.length; i++){
                    if(userCartToStorage[i].productInfo.pid === userCartToStorage2.productInfo.pid){
                      userCartToStorage[i].count += 1
                      foundLocation = true
                      break
                    }
                  }
                  if(!foundLocation){
                    userCartToStorage.push(userCartToStorage2)
                  }
                  lookAtCart(userCartToStorage)
                  localStorage.setItem('userCart', JSON.stringify(userCartToStorage));
                  console.log(userCartToStorage)
                }
              }
              else{
                window.location.replace('/CartPage');
              }
                
                //console.log(userDataToStore)
                // localStorage.setItem('userCart', JSON.stringify(userDataToStore));
                //window.location.href = '/CartPage';
              }}>
                {itemsInCart && itemsInCart.includes(product.pid) ? 
                  "View In Cart" : "add to cart"
                }
                
            </button>
          </div>
        </div>
      ))}

        {verticalSpacer((windowSize.width * 0.5) + (windowSize.height * 0.8))}
    </div> 
  );
}

export default HomePage;